import configs from "../configs.js";

function getCurrentOrigin() {
  if (typeof window === "undefined" || !window.location?.origin) {
    return null;
  }

  return window.location.origin;
}

function getCurrentHostname() {
  if (typeof window === "undefined" || !window.location?.hostname) {
    return null;
  }

  return window.location.hostname;
}

function getConfiguredHostname(url) {
  try {
    return new URL(url).hostname;
  } catch (_error) {
    return null;
  }
}

function isSamePlatformHostname(hostname) {
  const currentHostname = getCurrentHostname();
  const configuredXrhubHostname = getConfiguredHostname(configs.XRHUB_URL);
  const configuredCustomHostname = getConfiguredHostname(configs.CUSTOM_HOST);
  const configuredHostnames = [configuredXrhubHostname, configuredCustomHostname].filter(Boolean);

  return (
    hostname === currentHostname ||
    configuredHostnames.includes(hostname) ||
    (currentHostname && currentHostname.endsWith(`.${hostname}`)) ||
    configuredHostnames.some(configured => configured.endsWith(`.${hostname}`) || hostname.endsWith(`.${configured}`))
  );
}

export function toCurrentOriginUrl(url) {
  if (typeof url !== "string" || url.trim().length === 0) {
    return null;
  }

  const value = url.trim();
  const currentOrigin = getCurrentOrigin();

  if (!currentOrigin) {
    return value;
  }

  if (value.startsWith("/")) {
    return `${currentOrigin}${value}`;
  }

  try {
    const parsed = new URL(value);

    if (!isSamePlatformHostname(parsed.hostname)) {
      return value;
    }

    return `${currentOrigin}${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch (_error) {
    return value;
  }
}
